import React from "react";

const Login = () => {
  return (
    <div>
      <h1>This is login page</h1>
    </div>
  );
};

export default Login;
